// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"TickertapeSettings_settingsContainer__0eHf9","settings-item":"TickertapeSettings_settings-item___PaFG","actionBtns":"TickertapeSettings_actionBtns__so85S"};